<template>
    <div class="acc-height mb-2">
        <h3 class="mb-4 pl-4">
            ОБЩИ УСЛОВИЯ ЗА ПОЛЗВАНЕ НА ПЛАТФОРМАТА АДМИНПЛЮС
        </h3>
        <p class="mb-0">
            <strong>I. Предмет</strong>
        </p>
        <p class="mb-0">
            Настоящите общи условия са предназначени да регулират отношенията между „АдминСофт Плюс“ ООД, ЕИК 203885156,
            седалище в гр. София и адрес 1784 София, бул. Цариградско шосе № 147, ет. 6, адрес на електронна поща -
            office@adminsoft.bg, регистрация по ЗДДС BG203885156, наричан по-долу за краткост Доставчик, от една страна,
            и Ползвателите на предлаганите от платформата АдминПлюс услуги на информационното общество в сферата на
            образованието.
        </p>
        <p class="mb-0">
            За ползване на услугите в платформата АдминПлюс е необходимо да се регистрирате чрез регистрационен код,
            който се получава еднократно от образователната институция (училище, детска градина, ЦСОП), в която
            работите, учите и/или учи Вашето дете. Ако нямате качеството на служител и/или ученик и/или родител в такава
            институция, не може да направите регистрация поради липса на регистрационен код.
        </p>
        <p>
            Регистрацията и последващото използване на услугите в платформата АдминПлюс не изискват заплащане на
            възнаграждение, такса или други подобни от страна на служители, ученици и родители. Ползването на услугите
            на платформата става въз основа на договор между АдминСофт Плюс ООД и образователната институция, в която
            работите, учите и/или учи Вашето дете.
        </p>
        <p class="mb-0">
            <strong>
                II. Ред за ползване на платформа „АдминПлюс“
            </strong>
        </p>
        <p class="mb-0">
            Ползването на услугите в платформа „АдминПлюс“ става след регистрация с получен от образователната
            институция регистрационен код и избрани от Вас потребителско име (валиден адрес на електронна поща) и
            парола. На този адрес ще получите:
        </p>
        <ul class="mb-0">
            <li>
                потвърждение за извършването на регистрацията и активиране на вашия профил;
            </li>
            <li>
                информация при забравена парола.
            </li>
        </ul>
        <p class="mb-0">
            Доставчикът не носи отговорност, в случай че услугата не може да се използва от Ползвателя поради
            несъществуващ, неточно изписан или променен адрес на електронна поща от негова страна.
        </p>
        <p class="mb-0">
            С попълване на данните за регистрация, поставянето на отметка за запознаване с общите условия и натискане на
            бутон „Регистрация“, „Направи регистрация“ или друго изявление в смисъл на съгласие, Ползвателят декларира,
            че желае да се регистрира в платформата „АдминПлюс“ и ще спазва всички условия на Доставчика.
        </p>
        <p class="mb-0">
            При извършване на регистрацията Ползвателят се задължава да предостави верни и актуални данни. Ползвателят
            се задължава своевременно да актуализира данните, посочени в регистрацията си, в случай на промяна.
        </p>
        <p class="mb-0">
            Ползвателят има право да използва платформата „АдминПлюс“ добросъвестно и по предназначение. При
            използването Ползвателят не трябва да използва софтуер, скриптове, програмни езици или други технологии,
            които биха могли да създадат затруднения в ползването й от другите ползватели. Ползвателят се задължава да
            не използва платформата „АдминПлюс“ в противоречие с приложимото законодателство.
        </p>
        <p class="mb-0">
            Ползвателят осигурява самостоятелно оборудването за достъп до Услугата и нейното управление.
        </p>
        <p class="mb-0">
            С оглед повишаване качеството на услугите, предоставяни от платформата „АдминПлюс“, извършване на
            профилактика, отстраняване на повреди и други свързани с това дейности, Доставчикът има право временно да
            ограничи или преустанови предоставянето на услугата. В тези случаи Доставчикът е задължен своевременно да
            възстанови предоставянето на услугата след отпадане на обстоятелството, което е причина за
            преустановяването.
        </p>
        <p>
            АдминСофт Плюс ООД си запазва правото да променя общите условия за ползване на платформата АдминПлюс, но
            само при настъпила промяна в договорните отношения с образователната институция. При настъпила промяна, по
            подходящ начин ще бъдат уведомени всички регистрирани потребители.
        </p>
        <p class="mb-0">
            <strong>III. Защита на личните данни</strong>
        </p>
        <p class="mb-0">
            Доставчикът предприема мерки за защита на личните данни на Ползвателя съгласно Регламент (ЕС) 2016/679 на
            Европейския парламент и на Съвета от 27 април 2016 година относно защитата на физическите лица във връзка с
            обработването на лични данни и относно свободното движение на такива данни и за отмяна на Директива 95/46/ЕО
            (Общ регламент относно защитата на данните) и Закона за защита на личните данни. За гарантиране на правото
            Ви на информираност съгласно чл. 13 и 14 от Регламент (ЕС) 2016/679 (Общ регламент относно защитата на
            данните), може да се запознаете с Политиката за защита на личните данни на доставчика, обявена на
            платформата.
        </p>
        <p>
            За да осигури поверителност на личните данни на Ползвателите, Доставчикът ще изпраща необходимите данни с
            оглед ползване на услугите на платформа „АдминПлюс“ само на адреса на електронната поща, който е бил посочен
            от Ползвателите в момента на регистрацията.
        </p>
        <p class="mb-0">
            <strong>IV. Използване на „бисквитки“</strong>
        </p>
        <p>
            „Бисквитките“ са кратка информация, която платформата АдминПлюс записва на компютъра или мобилното
            устройство на посетителя. „Бисквитките“, използвани от платформата „АдминПлюс“, са свързани единствено с
            предоставяне на услуги от разстояние чрез използването на електронни средства, след изрично изявление от
            страна на ползвателя на услугата. Тъй като ценим Вашето доверие, в нашата Политика за използване на
            „бисквитки“ Ви предоставяме информация за целите, основанията и категориите данни, които събираме чрез
            „бисквитките“.
        </p>
        <p class="mb-0">
            <strong>
                V. Изменение и достъп до общите условия
            </strong>
        </p>
        <p>
            Настоящите общи условия могат да бъдат изменяни от Доставчика, за което последният ще уведоми по подходящ
            начин всички регистрирани Ползватели на услугата.
        </p>
        <p class="mb-0">
            <strong>
                V. Прекратяване
            </strong>
        </p>
        <p>
            Ползването на услугите на платформата „АдминПлюс“ се прекратява с изтичане на договора със съответната
            образователна институция. Ако договорът с образователната институция продължава и през следваща/следващи
            учебни години, ползването на услугите не се прекъсва и не се изисква нова регистрация от ползвателите.
        </p>
        <p class="mb-0">
            <strong>
                VI. Други условия
            </strong>
        </p>
        <p class="mb-0">
            Евентуалната недействителност на някоя част от общите условия няма да води до недействителност на останалите
            части.
        </p>
        <p>
            За неуредените в общите условия въпроси се прилага законодателството на Република България.
        </p>

        <p class="mn-0">
            <strong>
                VII. Надзорни органи
            </strong>
        </p>
        <p class="mb-0">
            В случай че са засегнати Ваши права и законни интереси, ви предоставяме за сведение данни за контакт с
            надзорни органи, както следва:
        </p>
        <p class="mb-0">
            <strong>
                Комисия за защита на личните данни
            </strong>
        </p>
        <p class="mb-0">
            Адрес: София 1592, бул. „Проф. Цветан Лазаров“ № 2, Електронна поща: kzld@cpdp.bg, Интернет страница:
            www.cpdp.bg, За консултации по прилагането на Регламент (ЕС) 2016/679 и на националното законодателство за
            защита на личните данни - тел. 02/91-53-555
        </p>
        <p class="mb-0">
            <strong>
                Комисия за защита на потребителите
            </strong>
        </p>
        <p>
            Адрес: София 1000, ул. Врабча № 1, ет. 3-5 , гореща линия на потребителя: 0700 111 22 (цени според
            тарифния ви план), Уеб сайт: www.kzp.bg
        </p>
    </div>
</template>

<script>
    export default {
        name: "gdpr-terms-text"
    }
</script>

<style scoped>

</style>
